export default __webpack_public_path__ + "static/media/ecwid-icon.3a6f3855.png";